import script from "./OnboardingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnboardingPage.vue?vue&type=script&setup=true&lang=ts"

import "./OnboardingPage.vue?vue&type=style&index=0&id=9cf951b4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cf951b4"]])

export default __exports__